const ourSolutionsData = {
  preheading: 'Nuestras soluciones',
  preheadingIcon: '/images/fingo_icon.webp',
  titleText: 'Diversas soluciones tecnológicas pensadas en tu negocio',
  subtitleText: 'Impulsa tu gestión financiera con herramientas simples, inteligentes y a tu medida.',
  accordionsInfo: [
    {
      name: 'factoring',
      text: 'Anticipa tus facturas',
      subtext: 'Convierte tus facturas por cobrar en liquidez inmediata. Cobra hoy y haz crecer tu negocio.',
      video: '/videos/factoring.mp4',
    },
    {
      name: 'ordering',
      text: 'Anticipa tus órdenes de compra',
      subtext: 'Solicita financiamiento usando tus órdenes de compra como respaldo. Luego paga con transferencia o facturas.',
      video: '/videos/ordering.mp4',
    },
    {
      name: 'pronto_pago',
      text: 'Pronto pago',
      subtext: 'Permite a tus proveedores adelantar el cobro de sus facturas, sin costos ni riesgos, gracias a un convenio con Fingo.',
      video: '/videos/pronto_pago.mp4',
    },
    {
      name: 'confirming',
      text: 'Confirming',
      subtext: 'Extiende tus plazos de pago y deja que Fingo gestione y pague directamente a tus proveedores.',
      video: '/videos/confirming.mp4',
    },
  ],
};

export default ourSolutionsData;
